import React from 'react'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc'
import { SessionExpiredScreen } from '@pushly/aqe/lib/components'
import { AppState } from '../../stores/app'
import { AuthService } from '../../services/auth'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'

export const SessionExpirationScreen: React.FC<{}> = observer(() => {
    const appState = Container.get(AppState)
    const appSvc = useService(AppService)
    const authService = Container.get(AuthService)

    const visible = appState.isAuthenticated && (appSvc.sessionExpired || appState.sessionExpired)

    return (
        <SessionExpiredScreen
            visible={visible}
            onSignIn={() => authService.logout(true)}
        />
    )
})
